import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "suggestion-bubble"
}
const _hoisted_2 = { class: "bubble-content" }
const _hoisted_3 = { class: "bubble-message" }
const _hoisted_4 = { class: "bubble-actions" }

import { ref, onUnmounted } from "vue";
import { Icon } from "@iconify/vue";

interface Props {
  message: string;
  buttonText?: string;
  icon?: string;
  autoHideDelay?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TimerSuggestionBubble',
  props: {
    message: {},
    buttonText: { default: "Start" },
    icon: { default: "material-symbols:timer" },
    autoHideDelay: { default: 15000 }
  },
  emits: ["action", "dismiss"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const isVisible = ref(false);
let autoHideTimeout: ReturnType<typeof setTimeout> | null = null;

const show = () => {
  isVisible.value = true;
  autoHideTimeout = setTimeout(() => {
    dismiss();
  }, props.autoHideDelay);
};

const hide = () => {
  isVisible.value = false;
  if (autoHideTimeout) {
    clearTimeout(autoHideTimeout);
    autoHideTimeout = null;
  }
};

const dismiss = () => {
  hide();
  emit("dismiss");
};

const handleAction = () => {
  hide();
  emit("action");
};

__expose({ show, hide });

onUnmounted(() => {
  if (autoHideTimeout) {
    clearTimeout(autoHideTimeout);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "bubble" }, {
    default: _withCtx(() => [
      (isVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(Icon), {
                icon: __props.icon,
                class: "bubble-icon"
              }, null, 8, ["icon"]),
              _createElementVNode("span", _hoisted_3, _toDisplayString(__props.message), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "action-button",
                onClick: handleAction
              }, _toDisplayString(__props.buttonText), 1),
              _createElementVNode("button", {
                class: "dismiss-button",
                onClick: dismiss
              }, [
                _createVNode(_unref(Icon), { icon: "material-symbols:close" })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})